import {
  ClipboardClock,
  CreditCard,
  PackageCheck,
  PawPrint,
} from "lucide-react";

import { Accordion } from "../../../../components/ui/Accordion";
import { HistorySection } from "./sections/HistorySection";
import { PackagesSection } from "./sections/PackagesSection";
import { PetsSection } from "./sections/PetsSection";
import { SubscriptionsSection } from "./sections/SubscriptionsSection";

export function CustomerDetailsSections({ details }) {
  return (
    <Accordion.Root
      name="customer-details"
      className="gap-2"
      options={{ type: "multiple", defaultOpen: [] }}
    >
      <Accordion.Item icon={PawPrint} title="Pets">
        <Accordion.Content>
          <PetsSection pets={details.pets} />
        </Accordion.Content>
      </Accordion.Item>

      <Accordion.Item
        icon={CreditCard}
        title="Assinaturas"
      >
        <Accordion.Content>
          <SubscriptionsSection subscriptions={details.subscriptions} />
        </Accordion.Content>
      </Accordion.Item>

      <Accordion.Item
        icon={PackageCheck}
        title="Pacotes ativos"
      >
        <Accordion.Content>
          <PackagesSection packages={details.activePackages} />
        </Accordion.Content>
      </Accordion.Item>

      <Accordion.Item
        icon={ClipboardClock}
        title="Histórico"
      >
        <Accordion.Content>
          <HistorySection services={details.serviceHistory} purchases={details.purchaseHistory} />
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
}
